import type { AutocompleteRenderInputParams } from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";

type RenderInputWithLoadingProps = {
  params: AutocompleteRenderInputParams;
  label: string;
  textFieldParams?: TextFieldProps;
  loading: boolean;
  loadingText?: string;
};

const renderInputWithLoading = ({
  params,
  label,
  textFieldParams,
  loading,
  loadingText,
}: RenderInputWithLoadingProps) => {
  return (
    <TextField
      {...params}
      {...textFieldParams}
      label={label}
      placeholder={loading ? loadingText : undefined}
      slotProps={{
        input: {
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        },
        htmlInput: {
          autoComplete: "off",
          ...params.inputProps,
        },
      }}
    />
  );
};

export default renderInputWithLoading;
